import { render, staticRenderFns } from "./IconMonedas.vue?vue&type=template&id=d5dc0134"
import script from "./IconMonedas.vue?vue&type=script&lang=js"
export * from "./IconMonedas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports